import React from 'react';
const testimonials = [['JH', 'J’ai organisé toute ma saison en une nuit. Chaque entraînement a maintenant un but précis.', 'James H.', 'France'], ['MK', 'Mon équipe a plus progressé en deux mois que durant toute la saison précédente.', 'Mark K.', 'France'], ['SP', 'Tout est clair et prêt à appliquer. Je gagne un temps précieux chaque semaine.', 'Sunita P.', 'France'], ['RT', 'Le protocole de culture d’équipe a tout changé. Mes conversations avec les joueurs sont maintenant pro.', 'Richard T.', 'France'], ['EW', 'Les modules rendent la préparation beaucoup plus simple et cohérente.', 'Emma W.', 'France'], ['AB', 'Enfin une méthode complète qui relie chaque facette du jeu.', 'Arun B.', 'France']];
export function TestimonialsSection() {
  return <section className="bg-white px-5 py-20" data-id="element-219">
      <div className="mx-auto max-w-6xl" data-id="element-220">
        <div className="text-center" data-id="element-221">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-[#d4af37]" data-id="element-222">
            Ce que disent les entraîneurs
          </p>
          <h2 className="mt-3 font-display text-4xl font-bold uppercase leading-none sm:text-5xl" data-id="element-223">
            Ils font confiance à{' '}
            <span className="text-[#b18b18]" data-id="element-224">RUGBY PRÊT</span>
          </h2>
          <p className="mt-3 text-sm font-bold text-[#5A5A66]" data-id="element-225">
            ★★★★★ 4.9/5 · 500+ entraîneurs satisfaits
          </p>
        </div>
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-226">
          {testimonials.map(([initials, quote, name, location]) => <figure key={name} className="flex min-h-[250px] flex-col border border-[#E5E5EA] bg-[#FAFAFA] p-6" data-id="element-227">
              <div className="flex items-center gap-3" data-id="element-228">
                <span className="grid h-10 w-10 place-items-center rounded-full bg-[#0A0A0A] text-xs font-bold text-white" data-id="element-229">
                  {initials}
                </span>
                <span className="text-[#d4af37]" aria-label="5 étoiles sur 5" data-id="element-230">
                  ★★★★★
                </span>
              </div>
              <blockquote className="mt-5 flex-1 text-sm font-medium italic leading-relaxed text-[#0A0A0A]" data-id="element-231">
                “{quote}”
              </blockquote>
              <figcaption className="mt-5" data-id="element-232">
                <p className="text-sm font-bold" data-id="element-233">{name}</p>
                <p className="text-xs font-medium text-[#5A5A66]" data-id="element-234">{location}</p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}